<template>
    <WCard class="ImportGenerate pos-r">
        <WLoading
            :text="this.$t('imports.create.generate.default')"
            visible
        />
    </WCard>
</template>
<script>
import {
    Api, apiRequest, notifyError, notifySuccess,
} from '@/api'
import { entityMixin } from '@/mixins'
import { STATUS, PHASES, SOURCES } from '@/entities/imports'

const DELAY = 5000

export default {
    name: 'ImportGenerate',
    mixins: [entityMixin],
    metaInfo () {
        return {
            title: this.$t('admin.navigation.imports.create'),
        }
    },
    entity () {
        return {
            breadcrumbs: [
                {
                    key: 'AdminImportsList',
                    label: this.$t('imports.create.title'),
                    to: { name: 'AdminImportsList' },
                },
                {
                    key: 'AdminImportsGenerate',
                    label: this.$t('imports.steps.generate'),
                },
            ],
        }
    },
    data () {
        return {
            id: null,
        }
    },
    watch: {
        id () {
            this.clearInterval()
            this.interval = window.setInterval(this.getImport, this.delay)
        },
    },
    mounted () {
        const { id } = this.$route.params || {}
        if ([undefined, null].includes(id)) this.$router.back()

        this.id = id
        this.delay = DELAY
    },
    beforeDestroy () {
        this.clearInterval()
    },
    methods: {
        clearInterval () {
            clearInterval(this.interval)
        },
        handleSuccess ({ status, phase, source }) {
            if (status === STATUS.completed) {
                if (source === SOURCES.PREQUIN) {
                    this.$router.push({ name: 'AdminImportsList' })
                    notifySuccess(this.$t('imports.create.modals.SUCCESS'))()
                } else {
                    this.$router.push({ name: 'AdminImportCreatePreview' })
                }
            } else if (status === STATUS.pendingReview && phase === PHASES.VALIDATION) {
                this.$router.push({ name: 'AdminImportsCreateValidation', params: { id: this.id } })
            }
        },
        handleError () {
            notifyError(this.$t('imports.create.modals.ERROR'))()
            this.$router.push({ name: 'AdminImportsList' })
        },
        async getImport () {
            apiRequest(Api().imports.getSource(this.id))
                .then(({ data }) => {
                    const { import: importData = {} } = data
                    const isFailed = ![STATUS.cancelled, STATUS.failed].includes(importData.status)
                    if (isFailed) this.handleSuccess(importData)
                    else this.handleError()
                })
                .catch(this.handleError)
        },
    },
}
</script>
<style lang="scss" scoped>
.ImportGenerate {
	width: 100%;
    @include admin-screen-height(54px);

    &::v-deep .Body {
        padding: 0;
    }
}
</style>
